import logo_freeway from '../../../statics/logo/logo_freeway.svg'
import banner_raffle from '../../../statics/img/banner_raffle.jpg'
import GetAWinner from './getWinner'
import { useState } from 'react'
import WinnerSelected from './winnerSelected'
import { useAppSelector } from '../../../store/hooks'

export default function Winner({ }) {
  const { raffleInfo } = useAppSelector((state) => state.raffle)
  const [tab, setTab] = useState((raffleInfo !== '') ? 2 : 1)

  return (<>
    <div className="c-winner">
      <div className="c-winner-info">
        <h1>Text Reference Let’s Get Started</h1>
        <p>Text reference: below are the active PURLs campaigns that have been assigned to you.</p>
      </div>
      <div className="c-winner-management">
        <div className="c-winner-management-header">
          <div className="c-winner-management-header-brand">
            <img src={logo_freeway} alt="" />
          </div>
          <div className="c-winner-management-header-campaign">
            <img src={banner_raffle} alt="" />
          </div>
        </div>
        {(tab === 1) && <GetAWinner setTab={setTab} create={true} />}
        {(tab === 2) && <GetAWinner setTab={setTab} />}
        {(tab === 3) && <WinnerSelected setTab={setTab} />}
      </div>
    </div>
  </>
  )
}